<template>
	<div class="notesdetails">
		<vx-card title="企业文化记录详情">
			<vs-breadcrumb :items="[{title: '记录管理',url: '/admin/notes'},{title: '记录详情',active: true}]"></vs-breadcrumb>
		</vx-card>
		<div class="mydetails m-4 flex ">
			<div class="w-1/4 bg-grid-color-secondary h-12 px-2">
			    <vs-sidebar static-position default-index="1">
			      <div class="header-sidebar" slot="header">
			        <div style="display: flex;justify-content: center;align-items: center;flex-direction: column;">
			        	<vs-avatar  size="70px" color="primary" text="龙翔" style="font-size: 17px;" />
			        	<h5>{{user.userName}}({{user.phone}})</h5>
			        	<h5 class="mb-4 mt-2">{{user.deptName}}</h5>
			        </div>
			        <h4>企业文化考核项</h4>
					<p class="mt-4 text-danger" style="font-size: 16px;">当前总分：<span>{{grade}}</span></p>
			      </div>
				  <div class="px-6 py-4" v-for="(item,index) in info" :key="item.dimension">
				      <h5>{{rpBig(index+1)+'.'+item.dimension}}</h5>
				          <div class="flex mt-6 cursor-pointer" :class="isselect==index&&isitem==i?'text-primary':''" v-for="(t,i) in item.templateInfoVo" :key="i" @click="getItem(index,i,t)">
				              <span class="text-lg ml-3">{{(index*5+i)+1}}.{{t.behaviors}}<em class="text-danger">(得分：{{t.selfEvaluation}})</em></span>
				          </div>
				  </div>
			    </vs-sidebar>
			</div>
			<div class="w-3/4 bg-grid-color h-12 px-2" v-if="info">
				<vx-card :title="current.behaviors" class="p-10" style="min-height:75vh">
						<div class="item">
							<p class="mb-4"><span class="text-warning">行为标准：</span>{{current.standards}}</p>
							<p class="mb-4"><span class="text-warning">举证突出：</span>{{current.prominentEvidence}}</p>
							<p class="mb-4"><span class="text-warning">评分标准：</span>{{current.markingCriterion}}</p>
						</div>
						<vs-divider/>
						<div class="vx-col w-full flex" style="align-items: center;">
						<el-tooltip popper-class="popper" class="item" effect="dark"  placement="top-start">
							<div slot="content"><pre>{{current.firstMonthEvidence}}</pre></div>
							<i class="el-icon-warning-outline"></i>
							<p>上月填写内容示例</p>
						</el-tooltip>
						</div>
				        <div class="mt-5">
							<el-descriptions title="填报内容" :column="1" border>
							    <el-descriptions-item label="行为佐证" label-class-name="detailslabel">{{current.evidence||'无'}}</el-descriptions-item>
							    <el-descriptions-item label="佐证来源" label-class-name="detailslabel">{{current.evidenceSource || '无'}}</el-descriptions-item>
							    <el-descriptions-item label="自评分" label-class-name="detailslabel">
							      <el-tag size="small">{{current.selfEvaluation}}分</el-tag>
							    </el-descriptions-item>
							</el-descriptions>
							<vs-divider/>
							<el-descriptions title="评审结果"></el-descriptions>
				            <el-descriptions :column="1" border v-for="(item,index) in current.leaderScore" :key="index" class="mb-4">
				                <el-descriptions-item label="审核员" label-class-name="detailslabel">{{item.name}}</el-descriptions-item>
				                <el-descriptions-item label="评语" label-class-name="detailslabel">{{item.remarks || '无'}}</el-descriptions-item>
				                <el-descriptions-item label="评分" label-class-name="detailslabel">
				                  <el-tag size="small">{{item.leaderScore}}分</el-tag>
				                </el-descriptions-item>
				            </el-descriptions>
							<vs-divider/>
							<el-descriptions title="抽检点评" v-if="status==11"></el-descriptions>
							<el-descriptions :column="1" border  class="mb-4" v-if="status==11">
							    <el-descriptions-item label="点评语:" label-class-name="detailslabel" :contentStyle="{'color':'red'}">{{current.comment||'无'}}</el-descriptions-item>
							</el-descriptions>
				        </div>
				    </vx-card>
			</div>
		</div>
		
	</div>
	
</template>
<script>
	import { nowtime,rp } from "../../../utils/format"
	export default {
	    data() {
	        return {
				user:'',
				id:'',
				info:'',
				isselect:0,   //选择的维度
				isitem:0,     //选择的项
				current:'',   //当前选择项内容
				grade:0,      //总评分
				status:10,    //11为已抽检
			}
	    },
		mounted() {
			this.user=JSON.parse(localStorage.getItem("userdetails"));
			this.status=this.$route.query.status;
			this.id=this.$route.query.id;
			this.getdetails();
		},
		watch:{
			current:{
				handler(newvalue,oldvalue) {
					console.log("你在作甚",newvalue,oldvalue);
					this.info[this.isselect].templateInfoVo[this.isitem]=newvalue;
					this.getgrade();
				},
				deep: true
			}
		},
		methods:{
			rpBig(num){
				return rp(num);
			},
			getItem(index,i,item){		//一项的内容
				this.isselect=index;
				this.isitem=i;
				this.current=item;
				console.log("该项内容",index,item);
			},
			getgrade(){			//计算自评总分
				var that=this;
				that.grade=0;
				for(var i=0;i<that.info.length;i++){
					for(var j=0;j<that.info[i].templateInfoVo.length;j++){
						that.grade=parseInt(that.grade)+parseInt(that.info[i].templateInfoVo[j].selfEvaluation);
					}
				}
			},
			getdetails(){   //获取详情
				const that = this;
				this.$api.allscoredetails({id :that.id}).then(function (response) {
					console.log("详情：",response);
					if(response.code==0){
						 that.info=response.data;
						 that.current=that.info[that.isselect].templateInfoVo[that.isitem];
						 that.getgrade();
					}else{
						that.$vs.notify({
							  title:"提示",
							  color:'warning',
							  text:response.message,
							  position:'top-center'
						});
					}
				})
			},
		},
	}
</script>
<style type="text/css">
	.notesdetails .el-descriptions :not(.is-bordered) .el-descriptions-item__cell{
		white-space: pre-wrap !important;
	}
	.notesdetails .parentx-static{
		overflow:hidden;
		height:500px;
		position:relative;
	}
	.notesdetails .header-sidebar{
		display:flex;
		align-items:center;
		justify-content:center;
		flex-direction:column;
		width:100%;
	}
	.notesdetails h4{
		display:flex;
		align-items:center;
		justify-content:center;
		width:100%;
	}
	.notesdetails h5{
		font-weight: 600;
	}
	.notesdetails .vs-sidebar--background{
		background: none !important;
		max-width: 450px !important;
		width: auto !important;
	}
	.notesdetails .vs-sidebar .vs-sidebar--items{
		max-height: 65vh !important;
		overflow: auto !important;
	}
	.myculture .vs-sidebar--items{
		-ms-overflow-style: none !important; /* IE 10+ */
		scrollbar-width: none !important; /* Firefox */
	}
	::-webkit-scrollbar {
	  display: none; /* Chrome Safari */
	}
	.notesdetails .vs-sidebar{
		max-width: 450px;
	}
	.notesdetails .item{
		font-size: 16px;
	}
	.detailslabel{
		width:120px
	}
</style>
